import { useState } from 'react';
import type { BuyListDetailItem } from './types';

export const NO_LENGTH_IDS: ReadonlySet<string> = new Set();

export function useItemsInSellerQuotesFold(
  items: BuyListDetailItem[],
  platformProductLengthIdsInSellerQuotes: ReadonlySet<string>
) {
  const [shownLengthIds, setShownLengthIds] =
    useState<ReadonlySet<string>>(NO_LENGTH_IDS);
  const isInSellerQuotes = (item: BuyListDetailItem) =>
    platformProductLengthIdsInSellerQuotes.has(item.platformProductsLength.id);
  const itemsInSellerQuotes = items.filter(isInSellerQuotes);
  const isFoldOpen = itemsInSellerQuotes.every((item) =>
    shownLengthIds.has(item.platformProductsLength.id)
  );
  const showsItemsInSellerQuotes = itemsInSellerQuotes.length > 0 && isFoldOpen;

  return {
    itemsInSellerQuotes,
    listedItems: showsItemsInSellerQuotes
      ? items
      : items.filter((item) => !isInSellerQuotes(item)),
    showsItemsInSellerQuotes,
    platformProductLengthIdsHiddenInSellerQuotes: new Set(
      [...platformProductLengthIdsInSellerQuotes].filter(
        (lengthId) => !(isFoldOpen && shownLengthIds.has(lengthId))
      )
    ),
    toggleItemsInSellerQuotes: () =>
      setShownLengthIds(
        showsItemsInSellerQuotes
          ? NO_LENGTH_IDS
          : new Set(
              itemsInSellerQuotes.map((item) => item.platformProductsLength.id)
            )
      ),
  };
}
